// ------------------------------------------------------------------
// PURE MODULE: alphascaley_scrub.mod.js
// ------------------------------------------------------------------
import gsap from "gsap"; 

export function AlphaScaleyScrub() {
      const config = {
   direction: 1
  };
    let masterTimeline;

    function init(elements, totalSlides) {
        if (!elements || elements.length === 0) return;

        masterTimeline = gsap.timeline({ paused: true });
        
        // Duration of one slide's "zone"
        const step = 1 / totalSlides; 
        
        // We want the fade to take up half the step on either side of the peak
        // e.g. Fade In (0.5 step) -> Peak -> Fade Out (0.5 step)
        const fadeDur = step / 2;

        elements.forEach((el, index) => {
            if (!el) return;

            // --- SPECIAL HANDLING FOR SLIDE 1 (Index 0) ---
            // To loop perfectly, Slide 1 must be visible at 0 AND at 1.
            if (index === 0) {
                // 1. At the very start (0): Fade OUT (from Peak to Invisible)
                masterTimeline.fromTo(el, 
                    { opacity: 1, scale: 1, yPercent: 0 }, 
                    { opacity: 0, scale: 0.5, yPercent: 100, ease: "power1.in", duration: fadeDur },
                    0 // Insert at absolute start
                );

                // 2. At the very end (1): Fade IN (from Invisible to Peak)
                masterTimeline.fromTo(el, 
                    { opacity: 0, scale: 0.5, yPercent: 100 }, 
                    { opacity: 1, scale: 1, yPercent: 0, ease: "power1.out", duration: fadeDur, immediateRender: false },
                    1 - fadeDur // Insert right before the end
                );
            } 
            
            // --- ALL OTHER SLIDES ---
            else {
                // Calculate where this slide peaks (e.g., 0.1, 0.2...)
                const peakTime = index * step;
                
                // Start fading in earlier
                const insertTime = peakTime - fadeDur;

                masterTimeline.fromTo(el, 
                    { opacity: 0, scale: 0.5, yPercent: 100 },
                    { 
                        opacity: 1, scale: 1, yPercent: 0, 
                        duration: fadeDur, 
                        ease: "power1.inOut",
                        yoyo: true, // Go back down
                        repeat: 1   // Play twice: Fade In -> Fade Out
                    },
                    insertTime // [FIX] Correct position argument (3rd arg)
                );
            }
        });
    }

/*     function updateProgress(progress) {
        if (masterTimeline) {
            // Ensure we stay within 0-1 range for the timeline
            //masterTimeline.progress(progress % 1); 
			let val = (typeof progress !== 'undefined') ? progress : 0;
            let circlePercent = (val % 1 + 1) % 1;
            if (config.direction === -1) {     
            circlePercent = 1 - circlePercent;// reverse the percentage *before* sending it to DrawSVG
			}
			masterTimeline.progress(circlePercent);
    }

    return { init, updateProgress };
} */

function updateProgress(progress) {
        if (masterTimeline) {
            // [FIX] Use GSAP utility to wrap negatives correctly (0 -> -0.1 becomes 0.9)
            masterTimeline.progress(gsap.utils.wrap(0, 1, progress)); 
        }
    }

    return { init, updateProgress };
}